import { observer } from 'mobx-react';
import { useEffect } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { AnimationPanelViews } from 'types/AnimationPanelViews';
import { AssetSortOptions } from 'types/AssetSortOptions';

import Drawer from '../Drawer';
import UploadVersionButton from './UploadVersionButton';
import VersionFileRow from './VersionFileRow';

const DrawerBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e6e6;
  margin: 10px;
  background: #ffffff;
  border-radius: 8px;
`;

function VersionsDrawer() {
  const store_animation = store.animation;
  const assetsManager = store_animation?.assets;
  const assets = assetsManager?.folderContext;

  useEffect(() => {
    assetsManager?.setSortOption(AssetSortOptions.DATE_MODIFIED, 'desc');
  }, [assetsManager]);

  return (
    <Drawer
      label="Versions"
      panelName={AnimationPanelViews.VERSIONS}
      enableDropIndicator={true}
      headerContent={
        store_animation && (
          <UploadVersionButton
            onSelected={(file) =>
              void store_animation?.uploadAnimationFile(file)
            }
          />
        )
      }
    >
      {assets && assets.length > 0 && (
        <DrawerBodyContainer>
          {assets.map((asset) => (
            <VersionFileRow asset={asset} key={asset.id} />
          ))}
        </DrawerBodyContainer>
      )}
    </Drawer>
  );
}

export default observer(VersionsDrawer);
